import React from 'react';
import PropTypes from 'prop-types';

const OutlineCard = ({ color }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.43417 2.43992e-06C5.45604 3.63201e-06 5.47799 4.82411e-06 5.5 4.82411e-06L15.5658 2.43992e-06C16.4523 -4.73896e-05 17.2161 -9.01893e-05 17.8278 0.0821453C18.4833 0.170277 19.1117 0.369022 19.6213 0.878684C20.131 1.38835 20.3297 2.0167 20.4179 2.67221C20.5001 3.28388 20.5001 4.0477 20.5 4.9342V10.0658C20.5001 10.9523 20.5001 11.7161 20.4179 12.3278C20.3297 12.9833 20.131 13.6117 19.6213 14.1213C19.1117 14.631 18.4833 14.8297 17.8278 14.9179C17.2161 15.0001 16.4523 15.0001 15.5658 15H5.43417C4.54769 15.0001 3.78387 15.0001 3.17221 14.9179C2.5167 14.8297 1.88835 14.631 1.37868 14.1213C0.869022 13.6117 0.670277 12.9833 0.582145 12.3278C0.49991 11.7161 0.499953 10.9523 0.500002 10.0658L0.500005 5C0.500005 4.97799 0.500004 4.95604 0.500002 4.93417C0.499953 4.04769 0.49991 3.28387 0.582145 2.67221C0.670277 2.0167 0.869022 1.38835 1.37868 0.878684C1.88835 0.369022 2.5167 0.170277 3.17221 0.0821453C3.78387 -9.01893e-05 4.54769 -4.73896e-05 5.43417 2.43992e-06ZM3.43871 2.06431C3.00497 2.12263 2.86902 2.21677 2.7929 2.2929C2.71677 2.36902 2.62263 2.50497 2.56431 2.93871C2.50213 3.40121 2.5 4.02893 2.5 5V10C2.5 10.9711 2.50213 11.5988 2.56431 12.0613C2.62263 12.495 2.71677 12.631 2.7929 12.7071C2.86902 12.7832 3.00497 12.8774 3.43871 12.9357C3.90121 12.9979 4.52893 13 5.5 13H15.5C16.4711 13 17.0988 12.9979 17.5613 12.9357C17.995 12.8774 18.131 12.7832 18.2071 12.7071C18.2832 12.631 18.3774 12.495 18.4357 12.0613C18.4979 11.5988 18.5 10.9711 18.5 10V5C18.5 4.02893 18.4979 3.40122 18.4357 2.93871C18.3774 2.50497 18.2832 2.36902 18.2071 2.2929C18.131 2.21677 17.995 2.12263 17.5613 2.06431C17.0988 2.00213 16.4711 2 15.5 2H5.5C4.52893 2 3.90122 2.00213 3.43871 2.06431Z"
      fill={color}
    />
    <path
      d="M7.49942 10.375C7.49942 10.9962 6.99576 11.4999 6.37447 11.4999C5.75317 11.4999 5.24951 10.9962 5.24951 10.375C5.24951 9.75366 5.75317 9.25 6.37447 9.25C6.99576 9.25 7.49942 9.75366 7.49942 10.375Z"
      fill={color}
    />
    <path d="M1.875 4.75H19.1253V6.99991H1.875V4.75Z" fill={color} />
  </svg>
);

OutlineCard.propTypes = {
  color: PropTypes.string.isRequired,
};

export default OutlineCard;
